// src/PrivateRoute.js
import { Navigate } from "react-router-dom";
import { useEffect } from "react";

const PrivateRoute = ({ children, allowedRoles }) => {
  // Check localStorage for a saved "isAuth" flag (or token)
  const isAuth = localStorage.getItem("isAuth");
  const userRole = localStorage.getItem("userRole");
  const userObj = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const userId = userObj?.user_id;
  const token = localStorage.getItem("token");

  // Get additional role info from user object
  const userRoleFromObj = userObj?.role;
  const roleId =
    typeof userRoleFromObj === "object" ? userRoleFromObj.id : null;
  const roleName =
    typeof userRoleFromObj === "object"
      ? userRoleFromObj.name
      : userRoleFromObj;

  // Check if role is allowed (check both name and ID)
  const isRoleAllowed =
    allowedRoles.includes(userRole) ||
    allowedRoles.includes(roleName) ||
    allowedRoles.includes(roleId);

  // Debug auth data
  console.log("PrivateRoute - Auth state:", {
    isAuth,
    userRole,
    userId,
    roleId,
    roleName,
    allowedRoles,
    hasToken: !!token,
    isRoleAllowed,
  });

  // Verify that we have all required auth data
  useEffect(() => {
    // Additional check to ensure user data consistency
    if (
      isAuth === "true" &&
      (!userId || !token || (!userRole && !roleName && !roleId))
    ) {
      // If any required auth data is missing, clear localStorage and force redirect
      console.warn("Auth inconsistency detected - missing user data", {
        isAuth,
        userRole,
        roleId,
        roleName,
        userId,
        hasToken: !!token,
      });
      localStorage.clear();
      localStorage.setItem("isAuth", "false");
      window.location.href = "/app";
    }
  }, [isAuth, userId, token, userRole, roleName, roleId]);

  // If not authenticated, redirect to /app page
  if (isAuth !== "true") {
    console.log("Not authenticated, redirecting to /app");
    return <Navigate to="/app" replace />;
  }

  // If authenticated but role doesn't match allowed roles, redirect
  if (!isRoleAllowed) {
    console.log(`Role not allowed. Current roles:`, {
      userRole,
      roleName,
      roleId,
    });
    console.log(`Expected one of:`, allowedRoles);

    // Determine appropriate redirect based on any role information we can find
    const effectiveRole = userRole || roleName;
    const redirectPath =
      effectiveRole === "Administrator"
        ? "/"
        : effectiveRole === "Borrower"
        ? "/borrowerProfile"
        : "/app";

    // Use the appropriate redirectPath based on role instead of always redirecting to /app
    return <Navigate to={redirectPath} />;
  }

  return children;
};

export default PrivateRoute;
